import NoDashboardDataView from '../../atoms/alert/no-dashboard-data.view';
import BarInfoView from '../../molecules/common/bar-info-view';
import BarChartSectionView from '../../molecules/common/bar-chart-section.view';
import Icon from '../../atoms/foundation/icon.view';
import { DashboardBtnMore } from '../../../assets/images/svg';
import { css } from '@emotion/react';
import Colors from '../../../types/colors';
import SurveyInfoSection from '../../molecules/common/survey-info-section';
import { Link } from 'react-router-dom';
import iconMap from '../../../assets/images/iconMap';
import LoadingSpinner from '../../atoms/foundation/loading-spinner.view';
import useDpi from '../../../hooks/useDpi';
import { IDashboardDataListItem, IDashboardPageData } from '../../../apis/v1/dashboard.api';
import { tmpDataList } from './tmp';

interface DashboardViewProps {
  dashboardPageData: IDashboardPageData;
  reportPageData: any;
  surveyNameMap: any;
  isLoading: boolean;
}

const DashboardView = ({ dashboardPageData, surveyNameMap, isLoading }: DashboardViewProps) => {
  const { iconSize, plusIcon } = useDpi();
  const wrapper = css`
    display: flex;
    flex-direction: column;
    background-color: ${Colors['Grey_01_bg']};
    width: 100%;
    height: 100%;
  `;
  const spinnerWrapper = css`
    display: flex;
    vertical-align: middle;
    justify-content: center;
    align-items: center;
    align-items: center;
    margin-top: 130px;
  `;

  //dashboardPageData.dataList
  //tmpDataList

  const flag = 0;
  const currentData = !flag ? dashboardPageData?.dataList : tmpDataList;

  return (
    <div css={wrapper}>
      <SurveyInfoSection />
      <BarInfoView userName={dashboardPageData?.nm} />
      {isLoading ? (
        <div css={spinnerWrapper}>
          <LoadingSpinner />
        </div>
      ) : (
        <>
          {typeof dashboardPageData !== 'undefined' && dashboardPageData.dataList.length ? (
            currentData.map((value: IDashboardDataListItem, index: number) => {
              const surveyName = surveyNameMap[value.surveyType];
              const koreanLetters = value.graphNm.trim(); // Trim leading and trailing spaces

              const lineInfo = (() => {
                if (!value.legendLineInfo) {
                  const legendFromColorLineInfo = Object.values(value.colorLineInfo || {}).map((val) => val || 0);
                  return {
                    legendLineInfo: [0, ...legendFromColorLineInfo],
                  };
                }
                return {};
              })();

              const MAX_LENGTH = 6;

              const newGraph = value.graph.slice(0, MAX_LENGTH);

              const newValue = {
                ...value,
                ...lineInfo,
                graph: newGraph,
              };

              return (
                <BarChartSectionView
                  key={index}
                  data={newValue}
                  iconName={koreanLetters}
                  icon={<Icon width={`${iconSize}px`} height={`${iconSize}px`} src={iconMap[value.graphCd]} />}
                  moreBtn={
                    <Link to={`/report/${value.surveyType}&${surveyName}`}>
                      <Icon src={DashboardBtnMore} width={`${plusIcon}px`} height={`${plusIcon}px`} />
                    </Link>
                  }
                />
              );
            })
          ) : (
            <NoDashboardDataView />
          )}
        </>
      )}
    </div>
  );
};

export default DashboardView;
